import { Availability } from '../../domain/Availability'
import { Area } from '../../domain/Area'
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core'
import { FormGroup } from '@angular/forms'

@Component({
    selector: 'app-area-selection',
    templateUrl: './area-selection.component.html',
})
export class AreaSelectionComponent implements OnChanges {

    @Input() availability!: Availability
    @Input() form!: FormGroup
    @Input() isLoading!: boolean
    @Output() areaSelected = new EventEmitter<Area>()
    @Output() joinWaitlistRequested = new EventEmitter<void>()
    selectedArea: Area | null = null
    showValidationError = false
    availableAreas: { area: Area; areaCanBeBooked: boolean }[] = []

    ngOnChanges(changes: SimpleChanges) {
        this.updateAvailableAreas()
    }

    private updateAvailableAreas() {
        this.availableAreas = this.availability.areasSortedByDisplayOrder.filter(area => {
            return !area.area.isHardcodedToBeHidden() && 
                   this.availability.areaIsConfiguredForChoices(
                       area.area.id,
                       this.form.get('selectedReasonId')?.value,
                       this.form.get('selectedEventId')?.value
                   )
        })
    }

    next() {
        if (this.selectedArea) {
            this.form.get('selectedAreaId')?.setValue(this.selectedArea.id)
            this.form.get('selectedAreaId')?.markAsDirty()
            this.areaSelected.emit(this.selectedArea)
        } else {
            this.showValidationError = true
        }
    }

    onAreaSelected(area: Area) {
        this.selectedArea = area
        this.showValidationError = false
    }

    isAreaReservable(area: Area): boolean {
        return this.availability.areaIsReservableWithConfiguration(
            area.id,
            this.form.get('partySize')?.value,
            this.form.get('selectedReasonId')?.value,
            this.form.get('selectedEventId')?.value
        )
    }
}
